import type { LucideIcon } from "lucide-react";
import { Package, Truck, ShieldCheck, RotateCcw, CreditCard, Headphones, Gift, BadgePercent, Lock, Star, Heart, Clock } from "lucide-react";

// Admin tema panelindeki FEATURE_ICONS ile AYNI isimler
export const FEATURE_ICONS: Record<string, LucideIcon> = {
  Package, Truck, ShieldCheck, RotateCcw, CreditCard, Headphones, Gift, BadgePercent, Lock, Star, Heart, Clock,
};

export function resolveFeatureIcon(name: string | undefined, fallback: LucideIcon): LucideIcon {
  return (name && FEATURE_ICONS[name]) || fallback;
}

interface FeatureCardsProps {
  themeConfig: Record<string, string>;
  /** Kart sarmalayıcı className — tema estetiğine göre dışarıdan verilir. */
  cardClassName?: string;
}

// Admin "Özellik Kartları" (feature1/2/3) — tüm home variant'larında ortak render.
export function FeatureCards({ themeConfig, cardClassName }: FeatureCardsProps) {
  const iconColor = themeConfig["theme.feature_icon_color"] || "var(--sf-accent)";
  const iconBg = themeConfig["theme.feature_icon_bg"] || "var(--sf-accent-light)";
  const titleColor = themeConfig["theme.feature_title_color"] || "var(--sf-text)";
  const descColor = themeConfig["theme.feature_desc_color"] || "#6b7280";

  const features = [
    {
      Icon: resolveFeatureIcon(themeConfig["theme.feature1_icon"], Package),
      title: themeConfig["theme.feature1_title"] || "500 ₺ Üzeri Kargo Bedava",
      desc: themeConfig["theme.feature1_desc"] || "Tüm siparişlerde geçerli",
    },
    {
      Icon: resolveFeatureIcon(themeConfig["theme.feature2_icon"], ShieldCheck),
      title: themeConfig["theme.feature2_title"] || "Güvenli Ödeme",
      desc: themeConfig["theme.feature2_desc"] || "256-bit SSL şifrelemesi",
    },
    {
      Icon: resolveFeatureIcon(themeConfig["theme.feature3_icon"], RotateCcw),
      title: themeConfig["theme.feature3_title"] || "Kolay İade",
      desc: themeConfig["theme.feature3_desc"] || "14 gün içinde ücretsiz iade",
    },
  ];

  const wrapClass = cardClassName || "ecommerce-card";

  const cardInner = (Icon: LucideIcon, title: string, desc: string) => (
    <>
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full sm:h-11 sm:w-11" style={{ backgroundColor: iconBg, color: iconColor }}>
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold" style={{ color: titleColor }}>{title}</p>
        <p className="mt-0.5 text-xs" style={{ color: descColor }}>{desc}</p>
      </div>
    </>
  );

  return (
    <>
      {/* Mobil: otomatik kayan şerit (hover/dokunuşta durur) */}
      <div className="group -mx-4 overflow-hidden px-4 sm:hidden">
        <div className="flex w-max gap-3 animate-marquee group-hover:[animation-play-state:paused] group-active:[animation-play-state:paused]">
          {[...features, ...features].map((f, i) => (
            <div key={i} aria-hidden={i >= features.length} className={`flex w-[68vw] shrink-0 items-center gap-3 p-4 ${wrapClass}`}>
              {cardInner(f.Icon, f.title, f.desc)}
            </div>
          ))}
        </div>
      </div>
      {/* Masaüstü: grid */}
      <div className="hidden gap-4 sm:grid sm:grid-cols-3">
        {features.map((f) => (
          <div key={f.title} className={`flex items-center gap-3 p-4 sm:gap-4 sm:p-6 ${wrapClass}`}>
            {cardInner(f.Icon, f.title, f.desc)}
          </div>
        ))}
      </div>
    </>
  );
}
